// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Georgia from '../_raw/flag/icon_flag_georgia.png';

export default () => <img src={Georgia} alt="Georgia" />;
